import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement, VNodeData, VNode } from 'vue';

@Component
export default class ClCardContent extends Vue {
  /**
   * The root component tag.
   */
  @Prop({
    default: 'div',
    type: String
  })
  public component!: string;

  render(h: CreateElement): VNode {
    const rootData: VNodeData = {
      class: 'cl-card-content'
    };
    return h(this.component, rootData, this.$slots.default);
  }
}
